export const onClickCallHandler = (e: any, phone: string) => {
  const btn = e.target.closest("button");
  if (btn.dataset.clicked === "false") {
    // hitUsedCarPhone(id);
    btn.textContent = "";
    const span = document.createElement("span");
    span.style.opacity = "0";
    span.textContent = phone;
    btn.insertAdjacentElement("beforeend", span);
    span.animate([{ opacity: "0" }, { opacity: "1" }], {
      duration: 500,
      fill: "forwards",
    });
  } else {
    window.open(`tel:${phone}`);
  }
  btn.dataset.clicked = "true";
}